import kitchenInstance from '../instance'

const createKitchenMonitorConfig = (data) => {
	return kitchenInstance.post('/kitchenMonitorConfigs', data)
}

export default createKitchenMonitorConfig
